import {Stack} from "@mui/material";

import {BmHelperText} from "~/components/helperText";
import {BmLabel} from "~/components/labels";
import {designColors} from "~/ui";

export interface BmEmptyStatePlaceholderProps {
  icon?: React.ReactElement;
  title: string;
  message?: string;
}

export const BmEmptyStatePlaceholder: React.FC<BmEmptyStatePlaceholderProps> = ({icon, title, message}) => (
  <Stack
    spacing={1}
    useFlexGap
    alignItems="center"
    sx={{
      p: 4,
      textAlign: "center",
      borderRadius: "10px",
      background: designColors.grey_6,
    }}
  >
    {icon}
    <BmLabel variant="semiBold">{title}</BmLabel>
    {message && <BmHelperText sx={{mt: 0}}>{message}</BmHelperText>}
  </Stack>
);
